import React from 'react'

import { FormattedMessage } from '@divvy-web/i18n'

import MarketingLink from '@sputnik/components/MarketingContent/MarketingLink'
import { URL } from '@sputnik/resources/constants'

const PrivacyPolicyLink = () => {
  return (
    <MarketingLink
      href={URL.BILL_PRIVACY_NOTICE}
      text={
        <FormattedMessage
          defaultMessage='View our privacy policy'
          id='sputnik.PrivacyPolicyLink__c6EUVk'
        />
      }
    />
  )
}

export default PrivacyPolicyLink
